import { EventEmitter } from "lucidjs";

let _instance = null;

class Registry {

	constructor() {
		if (_instance == null) {
			_instance = this;

			this._register = {};
			EventEmitter.call(this);
			Object.assign(this, EventEmitter.prototype);
		}

		return _instance;
	}

	static getInstance() {
		if (_instance === null) {
			_instance = new Registry();
		}

		return _instance;
	}

	static register(key, value, graceful) {
		return Registry.getInstance().register(key, value, graceful);
	}

	register(key, value, graceful) {
		if (key in this._register) {
			if (graceful) return;

			throw "Registry key '" + key + "' has already been set.";
		}

		this._register[key] = value;
		this.flag("available." + key, value);

		return this;
	}

	static unregister(key) {
		return Registry.getInstance().unregister(key);
	}

	unregister(key) {
		if (key in this._register) {
			delete this._register[key];
		}

		this.unflag("available." + key);

		return this;
	}

	static retrieve(key, callback) {
		return Registry.getInstance().retrieve(key, callback);
	}

	retrieve(key, callback) {
		this.bind("available." + key, callback);
	}
}

export default Registry;
